import { NgxsModule } from '@ngxs/store';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CoreModule } from './core';
import { InternetConnectionStatusComponent } from './shared/internet-connection-status/internet-connection-status.component';
import { CONFIG, registrationRoutesConfig } from './auto-registration/registration-config';
import { AutoRegistrationConfig } from './auto-registration/models/auto-registration-config';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

const appEnvironment = (window as any).environment || environment;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    InternetConnectionStatusComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CoreModule.withConfig({
      ApiBaseUrl: appEnvironment.ApiUrl,
    }),
    NgxsModule.forRoot([]),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: appEnvironment.production,
    }),
  ],
  providers: [
    DatePipe,
    ToastrModule,
    ToastrService,
    {
      provide: CONFIG,
      useValue: { routes: registrationRoutesConfig } as AutoRegistrationConfig,
    },
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
